import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_care-toolkit-pro/artifacts/xtaliuak_Just%20Care%20-%201.png";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 print:hidden" data-testid="site-footer">
      <div className="container-jcc py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <Link to="/" className="inline-flex items-center" aria-label="Just Care Community — home">
            <img
              src={LOGO_URL}
              alt="Just Care Community"
              className="h-16 md:h-20 w-auto object-contain bg-white rounded-xl p-2"
              draggable={false}
            />
          </Link>
          <p className="mt-4 text-sm leading-relaxed text-slate-400 max-w-md">
            A UK-focused resource, support and guidance hub for independent self-employed carers and the families who hire them. Independent care — done properly.
          </p>
          <p className="mt-4 text-xs text-slate-500 max-w-md">
            JCC is not a care agency. We do not employ, supply, vet, manage, supervise or guarantee carers, and we are not a CQC registered care provider.
          </p>
        </div>

        <div>
          <div className="overline text-slate-400 mb-4">For carers</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/for-carers" className="hover:text-white">Start independently</Link></li>
            <li><Link to="/pro-carer-circle" className="hover:text-white">Pro Carer Office</Link></li>
            <li><Link to="/resources?audience=carer" className="hover:text-white">Carer Resources</Link></li>
            <li><Link to="/carer-quiz" className="hover:text-white" data-testid="footer-carer-quiz-link">Carer Reflection Quiz</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline text-slate-400 mb-4">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/compare-memberships" className="hover:text-white">Compare Memberships</Link></li>
            <li><Link to="/wim-blog" className="hover:text-white">WIM Blog</Link></li>
            <li><Link to="/care-news" className="hover:text-white">Care News &amp; Policy Watch</Link></li>
            <li><Link to="/resources" className="hover:text-white">Resource Library</Link></li>
            <li><Link to="/shop" className="hover:text-white" data-testid="footer-shop-link">JCC Shop</Link></li>
            <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact Us</Link></li>
            <li><Link to="/privacy-policy" className="hover:text-white" data-testid="footer-privacy-policy-link">Privacy Policy</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="container-jcc py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-slate-500">
          <span>&copy; {new Date().getFullYear()} Just Care Community. All rights reserved.</span>
          <span className="flex items-center gap-2"><Mail className="w-4 h-4" /> hello@justcarecommunity.com</span>
        </div>
      </div>
    </footer>
  );
}
